export type Ease = (t: number) => number;
export const linear: Ease = (t) => t;
export const smoothstep: Ease = (t) => t * t * (3 - 2 * t);
export const easeInQuad: Ease = (t) => t * t;
export const easeOutQuad: Ease = (t) => t * (2 - t);
export const easeInOutQuad: Ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
export const easeInCubic: Ease = (t) => t * t * t;
export const easeOutCubic: Ease = (t) => 1 - Math.pow(1 - t, 3);
export const easeInOutCubic: Ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
export const easeOutBack: Ease = (t) => { const c1 = 1.70158, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };
export const easeInBack: Ease = (t) => { const c1 = 1.70158, c3 = c1 + 1; return c3 * t * t * t - c1 * t * t; };
export const easeOutElastic: Ease = (t) => {
  if (t === 0 || t === 1) return t;
  const c4 = (2 * Math.PI) / 3;
  return Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * c4) + 1;
};
export const easeOutBounce: Ease = (t) => {
  const n1 = 7.5625, d1 = 2.75;
  if (t < 1 / d1) return n1 * t * t;
  if (t < 2 / d1) return n1 * (t -= 1.5 / d1) * t + 0.75;
  if (t < 2.5 / d1) return n1 * (t -= 2.25 / d1) * t + 0.9375;
  return n1 * (t -= 2.625 / d1) * t + 0.984375;
};
export const clamp = (v: number, lo: number, hi: number): number => (v < lo ? lo : v > hi ? hi : v);
export const clamp01 = (v: number): number => clamp(v, 0, 1);
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
export const inverseLerp = (a: number, b: number, v: number): number => (a === b ? 0 : (v - a) / (b - a));
export const remap = (v: number, a: number, b: number, c: number, d: number): number => lerp(c, d, clamp01(inverseLerp(a, b, v)));
/** Frame-rate independent exponential approach: after `halfLife` seconds the gap to b halves. */
export const damp = (a: number, b: number, halfLife: number, dt: number): number => lerp(a, b, 1 - Math.pow(0.5, dt / Math.max(1e-6, halfLife)));
export const wrapAngle = (a: number): number => { a = (a + Math.PI) % (2 * Math.PI); if (a < 0) a += 2 * Math.PI; return a - Math.PI; };
export const angleLerp = (a: number, b: number, t: number): number => a + wrapAngle(b - a) * t;
export const moveTowards = (a: number, b: number, maxDelta: number): number => (Math.abs(b - a) <= maxDelta ? b : a + Math.sign(b - a) * maxDelta);
export const DEG = Math.PI / 180;
